import { AnyAction, combineReducers } from "redux";
import { Err } from "../../../typings";

export const FLIGHT_REPORT_FETCH_RECIPIENTS_PENDING =
  "FLIGHT_REPORT_FETCH_RECIPIENTS_PENDING";
export const FLIGHT_REPORT_FETCH_RECIPIENTS_FULFILLED =
  "FLIGHT_REPORT_FETCH_RECIPIENTS_FULFILLED";
export const FLIGHT_REPORT_FETCH_RECIPIENTS_REJECTED =
  "FLIGHT_REPORT_FETCH_RECIPIENTS_REJECTED";
export const FLIGHT_REPORT_UPDATE_RECIPIENTS_PENDING =
  "FLIGHT_REPORT_UPDATE_RECIPIENTS_PENDING";
export const FLIGHT_REPORT_UPDATE_RECIPIENTS_FULFILLED =
  "FLIGHT_REPORT_UPDATE_RECIPIENTS_FULFILLED";
export const FLIGHT_REPORT_UPDATE_RECIPIENTS_REJECTED =
  "FLIGHT_REPORT_UPDATE_RECIPIENTS_REJECTED";
export const FLIGHT_REPORT_WAS_RESET = "FLIGHT_REPORT_WAS_RESET";

export const QC_LIST_TYPE = "QC";
export const GCP_LIST_TYPE = "GCP";

export type FlightReportState = {
  pending: boolean;
  error: Err | null;
  recipients: Record<string, Array<string>>;
};

export type ListType = "QC" | "GCP";
export type FlightReportRecipients =
  | Record<ListType, Array<string>>
  | Record<string, never>;

function recipients(
  state: FlightReportRecipients = {},
  action: AnyAction,
): FlightReportRecipients {
  switch (action.type) {
    case FLIGHT_REPORT_FETCH_RECIPIENTS_PENDING:
      return state;
    case FLIGHT_REPORT_FETCH_RECIPIENTS_FULFILLED:
      return action.payload;
    case FLIGHT_REPORT_FETCH_RECIPIENTS_REJECTED:
    case FLIGHT_REPORT_WAS_RESET:
      return {};
    default:
      return state;
  }
}

function error(state: Err | null = null, action: AnyAction): Err | null {
  switch (action.type) {
    case FLIGHT_REPORT_FETCH_RECIPIENTS_PENDING:
    case FLIGHT_REPORT_FETCH_RECIPIENTS_FULFILLED:
    case FLIGHT_REPORT_UPDATE_RECIPIENTS_PENDING:
    case FLIGHT_REPORT_UPDATE_RECIPIENTS_FULFILLED:
      return null;
    case FLIGHT_REPORT_FETCH_RECIPIENTS_REJECTED:
    case FLIGHT_REPORT_UPDATE_RECIPIENTS_REJECTED:
      return action.payload;
    default:
      return state;
  }
}

function pending(state = false, action: AnyAction): boolean {
  switch (action.type) {
    case FLIGHT_REPORT_FETCH_RECIPIENTS_PENDING:
    case FLIGHT_REPORT_UPDATE_RECIPIENTS_PENDING:
      return true;
    case FLIGHT_REPORT_FETCH_RECIPIENTS_FULFILLED:
    case FLIGHT_REPORT_FETCH_RECIPIENTS_REJECTED:
    case FLIGHT_REPORT_UPDATE_RECIPIENTS_FULFILLED:
    case FLIGHT_REPORT_UPDATE_RECIPIENTS_REJECTED:
      return false;
    default:
      return state;
  }
}

export default combineReducers({ pending, error, recipients });
